import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSearchDetranDebitPayment } from "views/Partner/providers/get-debits.provider";
import { Container, Spinner } from "./styles";
import { getApiErrorMessages } from "services/errors";

export const DetranPaymentLoading: React.FC = () => {
  const [searchParams] = useSearchParams();
  const id_establishment = searchParams.get("id_establishment");
  const external_debit_id = searchParams.get("token");

  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const paymentBaseUrl = process.env.REACT_APP_PAYMENT_URL;

  const searchMutation = useSearchDetranDebitPayment({
    onSuccess(data) {
      if (!data?.success) {
        setError("Erro interno");
        return;
      }

      window.location.href = `${paymentBaseUrl}/payment-link/${data?.id_payment_link}`;
    },
    onError(err) {
      const error = err?.response?.data as any;
      setError(getApiErrorMessages({message: error?.message, error: error?.error, statusCode: error?.statusCode}) || "Erro interno");
    },
  });

  useEffect(() => {
    searchMutation.mutate({
      external_debit_id: external_debit_id ?? "",
      id_establishment : id_establishment ?? undefined,
    });
  }, []);

  if (error) {
    return (
      <Container style={{ textAlign: "center" }}>
          <p style={{ marginTop: 20, color: "#555" }}>
            Erro ao buscar proposta
          </p>

        <h2 style={{ fontSize: 28, marginTop: 10, fontWeight: 400 }}>
          {error}
        </h2>

        <button
          onClick={() => navigate(-1)}
          style={{
            marginTop: 30,
            padding: "10px 26px",
            background: "linear-gradient(90deg, #008CFF, #7B2EFF)",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            fontSize: 16,
          }}
        >
          Voltar
        </button>
      </Container>
    );
  }

  return (
    <Container>
      <Spinner />
      <p style={{ marginTop: 20 }}>Obtendo dados da proposta</p>
    </Container>
  );
};
